import {Component, forwardRef} from "@angular/core";
import {
    AbstractSearchControlComponent,
    registerSearchControl
} from "../../../entity/search/search-controls/abstract-search-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SimpleSearchControlComponent),
    multi: true
};

@Component({
    selector: "wbo-simple-search-control",
    templateUrl: "./simple-search-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        registerSearchControl(SimpleSearchControlComponent)
    ]
})
export class SimpleSearchControlComponent extends AbstractSearchControlComponent {
}
